import React from "react";

const NoDataFound = () => {
  return <div>NoDataFound</div>;
};

export default NoDataFound;
